import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedTab: "0",
  chat_data: [],
  // refreshData: false,
  availableStatus: "available",
  fcm_token: null,
};

const careAdminReducer = createSlice({
  name: "careAdminReducer",
  initialState,
  reducers: {
    setSelectedDomainAction(state, action) {
      state.careAdminDomain = action.payload;
    },
    chatState(state, action) {
      // console.log(state, action)
      state.chat_data = action.payload;
    },
    // setRefreshData(state, action) {
    //   state.refreshData = action.payload;
    // },
    setAvailableStatus(state, action) {
      state.availableStatus = action.payload;
    },
    setFcmToken(state, action) {
      state.fcm_token = action.payload;
    },
  },
});
export const {
  setSelectedDomainAction,
  chatState,
  // setRefreshData,
  setAvailableStatus,
  setFcmToken,
} = careAdminReducer.actions;
export default careAdminReducer.reducer;
